import { useLocation } from 'react-router-dom'

import SettingsLayout, { settingsActiveItemFor } from '@/layouts/SettingsLayout'

const SettingsFallback = () => {
  const { pathname } = useLocation()

  return (
    <SettingsLayout activeItem={settingsActiveItemFor(pathname)}>
      <div className="bg-surface rounded-lg p-6 shadow-card">
        <div className="animate-pulse">
          <div className="h-8 bg-neutral-20 rounded-sm w-1/4 mb-2" />
          <div className="h-4 bg-neutral-20 rounded-sm w-1/2 mb-6" />
          <div className="h-10 bg-neutral-20 rounded-sm" />
        </div>
      </div>
    </SettingsLayout>
  )
}

export default SettingsFallback
